export default __webpack_public_path__ + "static/media/bg2.c42e7415.png";